import { render, staticRenderFns } from "./EditAccountTypeModal.vue?vue&type=template&id=b751364e&lang=pug&"
import script from "./EditAccountTypeModal.vue?vue&type=script&lang=js&"
export * from "./EditAccountTypeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports